import Emitter from "./Emitter";

export default class setGameConfig extends Emitter {
    constructor(gb) {
        super(gb);
    }

    _default(payload) {
        this.emitGame({ wpgaction: "setGameConfig", data: { "emitToTop": true } });
    }
}
